import styled from "styled-components";

export const CardCompany = styled.div`
    min-height: 106px;
    box-shadow: 0px 6px 20px var(--vo-escuro-8) !important;
    border-radius: 8px !important;
    border-color: var(--vo-escuro-8) !important;
    background: white;
`
export const CardCounter = styled.div`
    min-width: 198px;
    max-width: 224px;
    height: 180px;
    box-shadow: 0px 6px 20px var(--vo-escuro-8) !important;
    border-radius: 8px !important;
    border-color: var(--vo-escuro-8) !important;
    padding: 16px;
    background: white;
`
export const LogoCardCounter = styled.div`
    height: 48px;
    display: flex;
    align-items: center;
    font-feature-settings: 'liga' off;
`
export const ContainerLogo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: color-mix(in srgb, var(--color-brand-live) 65%, white);
    box-shadow: 0px 6px 20px var(--vo-escuro-8);
    border-radius: 12px;
`
export const CardPendingPolicies = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
    gap: 10px;
    height: 338px;
    box-shadow: 0px 6px 20px var(--vo-escuro-8) !important;
    border-radius: 8px !important;
    border-color: var(--vo-escuro-8) !important;
    background: white;
`
export const CardStatusControls = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
    height: 338px;
    box-shadow: 0px 6px 20px var(--vo-escuro-8) !important;
    border-radius: 8px !important;
    border-color: var(--vo-escuro-8) !important;
    background: white;
`

export const ItemPendingPolicy = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: bold;
    &:hover {
        cursor: pointer;
    }
`

export const TopBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 2rem 0;
    flex-direction: column;
`
export const TopGraph = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`
export const BlockList = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-around;
`

export const SingleBlock = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    width: 30%;
    justify-content: space-around;
`

export const InfoBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 370px;
    box-shadow: 0px 6px 20px var(--vo-escuro-8) !important;
    border-radius: 16px !important;
    border: 1px solid var(--vo-cloud);
    padding: 16px;
    margin-bottom: 40px;
    gap: 5px;
    background: white;
`

export const InfoCDNBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 500px;
    min-width: 300px;
    box-shadow: 0px 6px 20px var(--vo-escuro-8) !important;
    border-radius: 16px !important;
    border: 1px solid var(--vo-cloud);
    padding: 16px;
    margin-bottom: 40px;
    gap: 5px;
    flex: 1;
    background: white;
`

export const InfoCertBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    min-width: 300px;
    box-shadow: 0px 6px 20px var(--vo-escuro-8) !important;
    border-radius: 16px !important;
    border: 1px solid var(--vo-cloud);
    padding: 16px;
    margin-bottom: 40px;
    gap: 5px;
    flex: 1;
    background: white;
`

export const InfoVulBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    min-width: 300px;
    box-shadow: 0px 6px 20px var(--vo-escuro-8) !important;
    border-radius: 16px !important;
    border: 1px solid var(--vo-cloud);
    padding: 16px;
    margin-bottom: 40px;
    gap: 5px;
    flex: 1;
    background: white;
`
export const InfoVulFullBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    min-width: 300px;
    box-shadow: 0px 6px 20px var(--vo-escuro-8) !important;
    border-radius: 16px !important;
    border: 1px solid var(--vo-cloud);
    padding: 0;
    margin-bottom: 40px;
    gap: 5px;
    background: white;
`

export const BlockContent = styled.div`
    justify-content: center;
    text-align: center;
    align-items: center;
    margin-top: 20px;
    overflow: auto;
    padding-bottom: 10px;

`
export const BlockContentTable = styled.div`
    justify-content: center;
    text-align: center;
    align-items: center;
    margin-top: 20px;
    overflow: auto;
    padding-bottom: 10px;

`
export const TableLane = styled.div`
    display: flex;
    justify-content: space-around;;
    text-align: center;
    align-items: center;
`

export const TableTitle = styled.p`
    width: 7rem;
`

export const TableTxt = styled.p`

    text-overflow: ellipsis;

`

export const EmptyInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 55vh;
  width: 100%;
  padding: 0 16px;
`

export const EmptyCard = styled.div`
  background: white;
  border-radius: 14px;
  padding: 60px 40px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
  text-align: center;
  max-width: 560px;
  width: 100%;
`

export const EmptyIconWrap = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 18px;
  background: linear-gradient(135deg, var(--vo-cobalto), var(--vo-capri));
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
`

export const EmptyTitle = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--vo-ink);
  margin: 0 0 10px;
  letter-spacing: -0.02em;
`

export const EmptyDesc = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  color: var(--vo-slate);
  margin: 0 0 28px;
  line-height: 1.65;
`

export const EmptyNote = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: var(--vo-steel);
  margin: 16px 0 0;
`

export const SideCards = styled.div`
    width: 30%;
    padding: 0 2.5rem;
`
export const MainCards = styled.div`
    width: 100%;
    max-width: 100%;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: stretch;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 20px;
    
    @media (min-width: 768px) {
        padding: 0;
    }
    
    @media (min-width: 1200px) {
        padding: 0;
    }
`
export const MainCardsLayout = styled.div`
    display: flex;
    flex-direction: column;
    aling-items: center;
    gap: 20px;
    padding-bottom: 20px;
`

export const MainBallLine = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-evenly;
    width: 100%;
`

export const BallsBlock = styled.div`
    display: flex;
    flex-direction: column;

    gap: 2rem;
    padding: 1rem 2rem;
`

export const BallsLine = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 1rem;

`

export const CompareBlock = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
export const CompareBallsLine = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: row;
    width: 100%;
`

export const ScanBtnWrap = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const ScanBtn = styled.button`
  height: 48px;
  background: linear-gradient(135deg, var(--vo-cobalto), var(--vo-capri));
  color: white;
  border: none;
  border-radius: 12px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  padding: 0 32px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  &:hover { opacity: 0.9; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`

export const ScannedLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  width: 100%;
`

export const PieBlock = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 15rem;
`

export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
  
  @media (min-width: 768px) {
    padding: 0;
  }
`

export const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
`

export const SideLog = styled.div`
    width: 30%;
    display: flex;
    flex-direction: column;
    background-color: var(--vo-cloud);
    border-radius: 50px 0 0 50px;
    padding: 2rem;
    gap: 20px;
`

export const LogContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
`

export const LogCard = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    gap: 10px;
    height: 100px;
    width: 90%;
    box-shadow: 0px 6px 20px var(--vo-escuro-8) !important;
    border-radius: 12px !important;
    border-color: var(--vo-escuro-8) !important;
    background: white;
`

export const LogArrow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
`

export const CardContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    min-width: 60%;
    justify-content: space-between;
`
